// Diff do formulário por assunto (H1, PO1-3259): o que vai no PUT /parametros/:escopo/lote.
//
// `formulario` é o array de GET /parametros/:escopo/formulario; `alterados` é o mapa
// idParametro (String) → valor novo que o usuário mexeu na tela. A chave é o Id, não
// o nome: o catálogo tem nomes repetidos entre módulos (ex.: AutoAssociarTransportadora
// em 87/NFE e 164/CTE; AutoCadastrarTransportadora em 98 e 154). Regras:
//   - valor igual ao original não é enviado (o usuário voltou atrás na mão);
//   - senha: o backend nunca devolve o valor (vem null + hasValue). '' significa
//     "manter a salva", então nem é enviado; só vai quando há texto novo;
//   - '' nos demais tipos VAI (o backend apaga a linha e o parâmetro volta ao padrão);
//   - Id que não está no formulário é ignorado.
// Item enviado: { idParametro, nome, valor } — o backend prioriza o idParametro.
import { getNormalizedValue, normalizeType } from "../renderControl";

export function chaveDe(param) {
  return param && param.idParametro !== null && param.idParametro !== undefined ? String(param.idParametro) : null;
}

export function ehSenha(param) {
  return normalizeType(param && param.tipo) === "password";
}

export function valorOriginal(param) {
  return getNormalizedValue(param ? param.valor : null);
}

// Diz se `valor` difere do que está gravado para `param` (mesma regra do diff).
export function valorMudou(param, valor) {
  if (!param) return false;
  const novo = getNormalizedValue(valor);
  if (ehSenha(param)) return novo !== "";
  return novo !== valorOriginal(param);
}

export function calcularValoresParaSalvar(formulario, alterados) {
  const porId = {};
  (formulario || []).forEach((p) => {
    const chave = chaveDe(p);
    if (chave) porId[chave] = p;
  });
  const saida = [];
  Object.keys(alterados || {}).forEach((chave) => {
    const param = porId[String(chave)];
    if (!param) return;
    const novo = getNormalizedValue(alterados[chave]);
    if (!valorMudou(param, novo)) return;
    saida.push({ idParametro: param.idParametro, nome: param.nome, valor: novo });
  });
  return saida;
}

// Mapa idParametro (String) → valor "em vigor na tela": o alterado quando existe,
// senão o gravado.
export function valoresAtuaisDoFormulario(formulario, alterados) {
  const mapa = {};
  const alt = alterados || {};
  (formulario || []).forEach((p) => {
    const chave = chaveDe(p);
    if (!chave) return;
    mapa[chave] = Object.prototype.hasOwnProperty.call(alt, chave) ? getNormalizedValue(alt[chave]) : valorOriginal(p);
  });
  return mapa;
}

// Mapa nome → valor a partir dos valores atuais por Id (para o "Testar conexão",
// cujo contrato segue por nome; os campos de conector têm nome único).
export function valoresPorNome(params, valoresPorId, { omitirSenhaVazia = false } = {}) {
  const saida = {};
  (params || []).forEach((p) => {
    const chave = chaveDe(p);
    if (!chave || !p.nome) return;
    const v = getNormalizedValue(valoresPorId ? valoresPorId[chave] : null);
    if (omitirSenhaVazia && ehSenha(p) && v === "") return;
    saida[p.nome] = v;
  });
  return saida;
}
